// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.equipmentBlock__3HwRr {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 100px);
  padding: 25px;
  row-gap: 25px;
  overflow-y: auto;
}
.equipmentBlock__3HwRr::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.equipmentBlock__3HwRr::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.equipmentBlock__3HwRr::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.equipmentBlock__3HwRr::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}
@media (max-width: 1024px) {
  .equipmentBlock__3HwRr {
    padding: 15px;
    row-gap: 15px;
  }
}

.equipmentPanelContainer__kyqiH {
  display: flex;
  padding: 15px 25px;
  justify-content: space-between;
  align-items: center;
  background: var(--tables-primary-row-surface-default);
  border: 1px solid var(--header-stroke);
}

.searchBlock__InlL0 {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 25px;
  background-color: var(--header-surface);
  height: 45px;
  border: 1px solid var(--header-stroke);
  border-top: unset;
}

.equipmentPanelBtns__O1N9z {
  gap: 1px;
  display: flex;
  margin-top: 20px;
  margin-right: 5px;
}

.switchItem__hWAyB {
  border-radius: 2px;
  background: var(--segments-chips-toggle-surface-default);
  padding: 5px;
  cursor: pointer;
}
.switchItem__hWAyB svg {
  width: 25px;
  height: 25px;
}

.activeItem___dbI3 {
  background: var(--segments-chips-toggle-surface-active);
}
.activeItem___dbI3 path {
  fill: var(--segments-chips-toggle-text-active);
}

.equipmentPanelFilter__CM7_R {
  display: flex;
  gap: 10px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/ManageEquipment/components/EquipmentsBlock/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;AAzEF;AAmBE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AAjBJ;AAoBE;EACE,+BAAA;EACA,kBAAA;AAlBJ;AAqBE;EACE,8BAAA;EACA,kBAAA;AAnBJ;AAsBE;EACE,gBAAA;EACA,kBAAA;AApBJ;AA2DE;EATF;IAUI,aAAA;IACA,aAAA;EAxDF;AACF;;AA2DA;EACE,aAAA;EACA,kBAAA;EACA,8BAAA;EACA,mBAAA;EACA,qDAAA;EACA,sCAAA;AAxDF;;AA2DA;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,uCAAA;EACA,YAAA;EACA,sCAAA;EACA,iBAAA;AAxDF;;AA2DA;EACE,QAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;AAxDF;;AA2DA;EACE,kBAAA;EACA,wDAAA;EACA,YAAA;EACA,eAAA;AAxDF;AA0DE;EACE,WAAA;EACA,YAAA;AAxDJ;;AA4DA;EACE,uDAAA;AAzDF;AA0DE;EACE,8CAAA;AAxDJ;;AA4DA;EACE,aAAA;EACA,SAAA;AAzDF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.equipmentBlock {\n  display: flex;\n  flex-direction: column;\n  height: calc(100vh - 100px);\n  padding: 25px;\n  row-gap: 25px;\n  overflow-y: auto;\n  @include scrollBar;\n\n  @media (max-width: 1024px) {\n    padding: 15px;\n    row-gap: 15px;\n  }\n}\n\n.equipmentPanelContainer {\n  display: flex;\n  padding: 15px 25px;\n  justify-content: space-between;\n  align-items: center;\n  background: var(--tables-primary-row-surface-default);\n  border: 1px solid var(--header-stroke);\n}\n\n.searchBlock {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0px 25px;\n  background-color: var(--header-surface);\n  height: 45px;\n  border: 1px solid var(--header-stroke);\n  border-top: unset;\n}\n\n.equipmentPanelBtns {\n  gap: 1px;\n  display: flex;\n  margin-top: 20px;\n  margin-right: 5px;\n}\n\n.switchItem {\n  border-radius: 2px;\n  background: var(--segments-chips-toggle-surface-default);\n  padding: 5px;\n  cursor: pointer;\n\n  svg {\n    width: 25px;\n    height: 25px;\n  }\n}\n\n.activeItem {\n  background: var(--segments-chips-toggle-surface-active);\n  path {\n    fill: var(--segments-chips-toggle-text-active);\n  }\n}\n\n.equipmentPanelFilter {\n  display: flex;\n  gap: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"equipmentBlock": `equipmentBlock__3HwRr`,
	"equipmentPanelContainer": `equipmentPanelContainer__kyqiH`,
	"searchBlock": `searchBlock__InlL0`,
	"equipmentPanelBtns": `equipmentPanelBtns__O1N9z`,
	"switchItem": `switchItem__hWAyB`,
	"activeItem": `activeItem___dbI3`,
	"equipmentPanelFilter": `equipmentPanelFilter__CM7_R`
};
module.exports = ___CSS_LOADER_EXPORT___;
